import React, { Component } from "react";

import {
  Dropdown,
  IDropdownStyles,
  IDropdownOption,
  Stack,
  IStackTokens,
  Icon,
  Separator,
  IIconStyles,
  Text,
} from "office-ui-fabric-react";

import { Card, ICardTokens, ICardSectionStyles } from "@uifabric/react-cards";

import TaskView from "./taskview";

import MatterList from "./matterlist";
import FavoriteList from "./favoritelist";
import MyMatterList from "./mymatterlist";

import "../styles/matterview.css";

import { FontWeights } from "@uifabric/styling";
import { resolve } from '../../webpack.config';

import Axios from 'axios';

interface IState {
  isLoaded: boolean;
  showTask: boolean;
  listView: string;
  workFlowURL: string;
}

const dropdownStyles: Partial<IDropdownStyles> = {
  dropdown: { width: 300 },
};

const options: IDropdownOption[] = [
  { key: "recent", text: "Recent Matters", data: { icon: "Clock" } },
  {
    key: "favorite",
    text: "Favorite Matters",
    data: { icon: "SingleBookmark" },
  },
  { key: "mymatter", text: "My Matters", data: { icon: "Contact" } },
];

const ListViewIcon = function (key: string) {
  if (key === "mymatter") return "Contact";
  if (key === "favorite") return "SingleBookmark";

  return "Clock";
};

const sectionStackTokens: IStackTokens = {
  childrenGap: 0,
  padding: `${15}px ${35}px ${35}px ${35}px`,
};

const onRenderOption = (option: IDropdownOption): JSX.Element => {
  return (
    <div>
      {option.data && option.data.icon && (
        <Icon
          style={iconStyles}
          iconName={option.data.icon}
          aria-hidden="true"
          title={option.data.icon}
        />
      )}
      <span>{option.text}</span>
    </div>
  );
};

const taskCardTokens: ICardTokens = {
  minWidth: 400,
  maxHeight: 300,
};

const iconStyles: IIconStyles = {
  root: {
    color: "#0078D4",
    fontSize: 18,
    fontWeight: FontWeights.regular,
    padding: 10,
    cursor: "pointer",
  },
};
const secondCardSectionStyles: ICardSectionStyles = {
  root: {
    backgroundColor: "#FFFFFF",
  },
};

const dashboardStackTokens: IStackTokens = {
  childrenGap: 10,
  padding: `${0}px ${0}px ${35}px ${0}px`,
};

const listCardSection: ICardSectionStyles = {
  root: {
    backgroundColor: "#FFFFFF",
  },
};

const cardDashboardTokens: ICardTokens = {
  childrenMargin: 10,
  width: 5,
};

class MatterView extends Component<{}, IState> {
  constructor(props: any) {
    super(props);

    this.state = {
      isLoaded: false,
      listView: "",
      showTask: true,
      workFlowURL: "",
      getUserSettingURL: "",
      setUserSettingURL: "",
      userName: ""
    };
  }

    componentDidMount() {
    this.getSettings().then(settings => {
      this.setState({
        getUserSettingURL: settings[0].getUserSettingURL,
        setUserSettingURL: settings[0].setUserSettingURL,
        userName: settings[1].userName
      }, () => {
        this.getUserSettings().then(userSettings => {
          // var isTrue = (userSettings[0] === 'true');
          var userView = userSettings[1];
          if (userView == '') {
            userView = 'recent';
          }
          this.setState({
            showTask: userSettings[0],
            listView: userView,
            workFlowURL: this.props.workFlowURL,
            isLoaded: true
          });
        });
      });
    })
  }

  getSettings() {
    var p1 = this.getAPISettings();
    var p2 = this.getUserSession();

    return Promise.all([p1, p2]).then(res => res);
  }

  getAPISettings() {
    return new Promise(resolve => {
      let apiURL = JSON.parse(localStorage.getItem("api"));
      resolve(
        apiURL
      );
    });
  }

  getUserSession() {
    return new Promise(resolve => {
      let userSession = JSON.parse(localStorage.getItem("userSession"));
      resolve(
        userSession
      );
    });
  }

  getUserSettings() {
    var p1 = this.getUserTaskBar();
    var p2 = this.getUserView();

    return Promise.all([p1, p2]).then(res => res);
  }

  onListChanged = (
    event: React.FormEvent<HTMLDivElement>,
    item: IDropdownOption
  ): void => {
    this.setUserView(item.key.toString());
    //localStorage.setItem('user-view', item.key.toString());
    this.setState({
      listView: item.key.toString(),
    });
  };

  getUserTaskBar() {
    var url = this.state.getUserSettingURL + "&key=user-taskbar&email=" + this.state.userName
    // return fetch(url, {
    //   method: "get"
    // }).then(res => res.text());
    return Axios.get(url).then(res => res.data);
  }

  getUserView() {
    var url = this.state.getUserSettingURL + "&key=user-view&email=" + this.state.userName
    // return fetch(url, {
    //   method: "get"
    // }).then(res => res.text());
    return Axios.get(url).then(res => res.data);
  }

  onToggleTask = () => {
    this.setUserTaskBar();
    this.setState({
      showTask: this.state.showTask ? false : true,
    });
  };

  setUserTaskBar() {
    var url = this.state.setUserSettingURL;
    const param = {
      email: this.state.userName,
      key: "user-taskbar",
      value: !this.state.showTask
    };

    // return fetch(url, {
    //   method: "post",
    //   headers: {
    //     "Content-Type": "application/json"
    //   },
    //   body: JSON.stringify(param)
    // }).then(res => res.text());

    return Axios.post(url, JSON.stringify(param)).then(res => res.data);
  }

  setUserView(type: string) {
    var url = this.state.setUserSettingURL;
    const param = {
      email: this.state.userName,
      key: "user-view",
      value: type
    };

    // return fetch(url, {
    //   method: "post",
    //   headers: {
    //     "Content-Type": "application/json"
    //   },
    //   body: JSON.stringify(param)
    // }).then(res => res.text());

    return Axios.post(url, JSON.stringify(param)).then(res => res.data);
  }

  public render() {
    const { isLoaded } = this.state;
    if (!isLoaded) return <div>Loading...</div>;
    else {
      return (
        <Stack horizontal tokens={sectionStackTokens} className="main-content">
          {this.state.showTask === true ? (
            <Stack.Item className="task-content">
              <Card className="task-card" tokens={taskCardTokens}>
                <Card.Section
                  className="task-card-section"
                  styles={secondCardSectionStyles}
                >
                  <TaskView workFlowURL={this.state.workFlowURL}></TaskView>
                </Card.Section>
              </Card>
            </Stack.Item>
          ) : (
              <Separator vertical />
            )}
          <Stack.Item grow={3} align="start" styles={listCardSection}>
            <Stack horizontal tokens={dashboardStackTokens}>
              <Stack.Item grow={3} className="dashboard-btn-holder">
                <Icon
                  iconName={this.state.showTask ? "ChevronLeft" : "ChevronRight"}
                  onClick={this.onToggleTask}
                  className="taskview-sidebar"
                  styles={iconStyles}
                />
                <Card
                  horizontal
                  className="card-dashboard"
                  tokens={cardDashboardTokens}
                >
                  <Card.Item align="center">
                    <Icon
                      className={this.state.showTask ? 'show-task' : 'hide-task'}
                      iconName="FabricOpenFolderHorizontal"
                      styles={iconStyles}
                      title='FE Dashboard'
                    />
                    <Text className={this.state.showTask ? 'show-task' : 'hide-task'}>FE Dashboard</Text>
                  </Card.Item>
                </Card>
                <Card
                  horizontal
                  className="card-dashboard"
                  tokens={cardDashboardTokens}
                >
                  <Card.Item>
                    <Icon className={this.state.showTask ? 'show-task' : 'hide-task'} title='Matter Dashboard' iconName="CRMReport" styles={iconStyles} />
                    <Text className={this.state.showTask ? 'show-task' : 'hide-task'}>Matter Dashboard</Text>
                  </Card.Item>
                </Card>
                <Card
                  horizontal
                  className="card-dashboard"
                  tokens={cardDashboardTokens}
                >
                  <Card.Item align="center">
                    <Icon className={this.state.showTask ? 'show-task' : 'hide-task'} title='Client Dashboard' iconName="ReportDocument" styles={iconStyles} />
                    <Text className={this.state.showTask ? 'show-task' : 'hide-task'}>Client Dashboard</Text>
                  </Card.Item>
                </Card>
              </Stack.Item>
            </Stack>
            <div className={"Matter-header icon-holder"}>
              <Icon
                className={"taskviewer-icon"}
                iconName={ListViewIcon(this.state.listView)}
                styles={iconStyles}
              />
              <Dropdown
                className={"list-view-selector icon-holder"}
                defaultSelectedKey={this.state.listView}
                options={options}
                styles={dropdownStyles}
                onRenderOption={onRenderOption}
                onChange={this.onListChanged}
              />
            </div>
            <div className="list-main-container">
              {this.state.listView === "recent" ? <MatterList></MatterList> : ""}
              {this.state.listView === "favorite" ? (<FavoriteList></FavoriteList>) : ("")}
              {this.state.listView === "mymatter" ? (<MyMatterList></MyMatterList>) : ("")}
            </div>
          </Stack.Item>
        </Stack>
      );
    }
  }
}

export default MatterView;
